import Validation from 'utils/validation.utils';

export const initialState = (state = {}) => {
  const {
    cifNumber = {
      value: '',
      disabled: true
    },
    productId = {
      value: '',
      disabled: false
    },
    committedAmount = {
      value: '',
      disabled: false
    },
    initialAmount = {
      value: '',
      disabled: false
    },
    orNumber = {
      value: '',
      disabled: false
    },
    accountId = {
      value: '',
      disabled: false
    }
  } = state;
  return {
    cifNumber: {
      name: 'cifNumber',
      label: `MIF Number`,
      ...cifNumber
    },
    productId: {
      name: 'productId',
      validations: [Validation.required({ noMessage: true })],
      required: true,
      ...productId
    },
    committedAmount: {
      name: 'committedAmount',
      required: false,
      placeholder: '0.00',
      ...committedAmount
    },
    initialAmount: {
      name: 'initialAmount',
      required: false,
      placeholder: '0.00',
      ...initialAmount
    },
    orNumber: {
      name: 'orNumber',
      required: false,
      ...orNumber
    },
    accountId: {
      name: 'accountId',
      required: false,
      ...accountId
    }
  };
};
